<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['articles']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Languages</div>
              <v-dialog style="float: right" v-model="articlesLanguagePieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Languages</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullArticlesLanguagePieChart'], 'FullArticlesLanguagePieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="articlesLanguagePieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullArticlesLanguagePieChart" ref="FullArticlesLanguagePieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="articlesLanguagePieChart">
                    <ArticlesLanguagePieChart v-bind:options="{}" v-bind:filters="getFilters"></ArticlesLanguagePieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['ArticlesLanguagePieChart'], 'ArticlesLanguagePieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="ArticlesLanguagePieChart" ref="ArticlesLanguagePieChart" style="height: 100%">
                <ArticlesLanguagePieChart v-bind:options="{}" v-bind:filters="getFilters"></ArticlesLanguagePieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Topics</div>
              <v-dialog style="float: right" v-model="articlesTopicsPieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Topics</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullArticlesTopicsPieChart'], 'FullArticlesTopicsPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="articlesTopicsPieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullArticlesTopicsPieChart" ref="FullArticlesTopicsPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="articlesTopicsPieChart">
                    <ArticlesTopicsPieChart v-bind:options="{}" v-bind:filters="getFilters"></ArticlesTopicsPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['ArticlesTopicsPieChart'], 'ArticlesTopicsPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="ArticlesTopicsPieChart" ref="ArticlesTopicsPieChart" style="height: 100%">
                <ArticlesTopicsPieChart v-bind:options="{}" v-bind:filters="getFilters"></ArticlesTopicsPieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Article Volume</div>
              <v-dialog style="float: right" v-model="articlesVolumeBarChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Article Volume</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullArticlesVolumeBarChart'], 'FullArticlesVolumeBarChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn icon dark @click.native="articlesVolumeBarChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullArticlesVolumeBarChart" ref="FullArticlesVolumeBarChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center" v-if="articlesVolumeBarChart">
                    <ArticlesVolumeBarChart v-bind:options="{}" v-bind:filters="getFilters"></ArticlesVolumeBarChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['ArticlesVolumeBarChart'], 'ArticlesVolumeBarChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 400px">
              <v-card-text id="ArticlesVolumeBarChart" ref="ArticlesVolumeBarChart" class="px-0" style="height: 100%">
                <ArticlesVolumeBarChart v-bind:options="{}" v-bind:filters="getFilters"></ArticlesVolumeBarChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      
      <v-flex xs12>
        <v-toolbar class="elevation-1 secondary" >
          <v-toolbar-side-icon><v-icon>fa-newspaper</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>Articles</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <v-select
              v-model="layout"
              :items="articleView"
              hide-details
              item-text="text"
              item-value="value"
              label="View"
              :menu-props="{maxHeight:'900'}">
              <template slot="selection" slot-scope="{ item, tile }">
                <span><v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>{{ item.text}}</span>
              </template>
              <template slot="item" slot-scope="{ item, tile }">
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          
          <v-flex xs3>
            <v-select
              v-model="sortBy"
              :items="articleSort"
              hide-details
              item-text="text"
              item-value="value"
              label="Sort By"
              :menu-props="{maxHeight:'900'}">
              <template slot="selection" slot-scope="{ item, tile }">
                <span><v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>{{ item.text}}</span>
              </template>
              <template slot="item" slot-scope="{ item, tile }">
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-tooltip bottom>
            <v-avatar slot="activator">
              <v-icon v-bind:class="[orderBy === 'ASC' ? 'ascending' : 'descending']" @click="orderChange">arrow_downward</v-icon>
            </v-avatar>
            <span>Ascending / Descending Order</span>
          </v-tooltip>
        </v-toolbar>
        <v-card>
          <v-card-text class="pa-0">
            <center>
              <ArticlesListing v-bind:options="{layout: layout, sortBy: sortBy, orderBy: orderBy}" v-bind:filters="getFilters"></ArticlesListing>
            </center>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
  .ascending {
    transform: rotate(-180deg);
    transition: 0.2s all ease-in-out;
  }
  .descending {
    transform: rotate(0deg);
    transition: 0.2s all ease-in-out;
  }
</style>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { snap } from '@/helpers/snapshots'
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import ArticlesVolumeBarChart from './charts/ArticlesVolumeBarChart.vue'
import ArticlesListing from './listings/ArticlesListing.vue'
import ArticlesLanguagePieChart from './charts/ArticlesLanguagePieChart.vue'
import ArticlesTopicsPieChart from './charts/ArticlesTopicsPieChart.vue'

export default {
  data () {
    return {
      expansionValue: 0,
      articlesVolumeBarChart: false,
      articlesLanguagePieChart: false,
      articlesTopicsPieChart: false,
      articleView: [
        {color: 'blue lighten-2', icon: 'dashboard', text: 'Grid', value: 'grid'},
        {color: 'purple lighten-2', icon: 'dns', text: 'Tiles', value: 'tiles'}
      ],
      orderBy: 'DESC',
      layout: 'grid',
      sortBy: '_tweeted_count',
      articleSort: [
        {color: 'orange lighten-2', icon: 'fas fa-calendar', text: 'Date Published', value: '_date_published'},
        {color: 'blue lighten-2', icon: 'fab fa-twitter', text: 'Tweet Count', value: '_tweeted_count'}
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('toggles', ['getFiltersChips']),
    ...mapGetters('filters', ['getFilters'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap,
    orderChange () {
      this.orderBy = this.orderBy === 'DESC' ? 'ASC' : 'DESC'
    }
  },
  components: {
    Filters,
    Counters,
    ArticlesVolumeBarChart,
    ArticlesListing,
    ArticlesLanguagePieChart,
    ArticlesTopicsPieChart
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Articles.vue